import Suppliers from './SuppliersController';

export default Suppliers;
